
import { language as lan_shipping } from "./shipping";
import { language as lan_stepNavConfig } from "./step-nav-config";
import { language as lan_payment } from "./payment";

let language = {
    ...lan_shipping,
    ...lan_stepNavConfig,
    ...lan_payment,
    CHECKOUT_CREATE_SAMPLE_ORDER_ISSUE_TITLE: "创建订单异常",
    CHECKOUT_CREATE_SAMPLE_ORDER_ISSUE_CONTENT: "尝试创建订单时发生问题。请再试一次。 如果问题仍然存在，请通过 {{supportmail}}联系我们的支持团队。",
    CHECKOUT_CREATE_SAMPLE_ORDER_ISSUE_BY_ADDRESS_CONTENT: "此订单的送货地址不在 {{appName}} 的服务覆盖范围内。请更改地址以继续此订单。{{regions}}",
    CHECKOUT_CREATE_SAMPLE_ORDER_ISSUE_BY_CURRENCY_CONTENT: "货币类型更改。请查看您的订单信息，然后重新下单。",
    CHECKOUT_CREATE_SAMPLE_ORDER_MISSING_SHIPPING_ADDRESS_TITLE: "缺少配送地址",
    CHECKOUT_CREATE_SAMPLE_ORDER_MISSING_SHIPPING_ADDRESS_CONTENT: "请确保您的配送地址非空。",
    CHECKOUT_CREATE_SAMPLE_ORDER_MISSING_BILLING_ADDRESS_TITLE: "缺少账单地址",
    CHECKOUT_CREATE_SAMPLE_ORDER_MISSING_BILLING_ADDRESS_CONTENT: "请确保您的账单地址非空。",
    CHECKOUT_CREATE_SAMPLE_ORDER_COUPON_TITLE: "优惠券超过最高限额",
    CHECKOUT_CREATE_SAMPLE_ORDER_COUPON_CONTENT: "您的订单只能使用1张优惠券，请您删除多余的优惠券。 ",
    // 步骤数据不完备
    CHECKOUT_STEP_INCOMPLETE_TITLE: "步骤数据校验失败",
    CHECKOUT_STEP_INCOMPLETE_CONTENT: "当前步骤数据不完整，不能跳过下一步。 ",
    CHECKOUT_PAGE_INIT_ISSUE_TITLE: "页面加载异常",
    CHECKOUT_PAGE_INIT_ISSUE_CONTENT: "加载此页时发生问题。 请刷新页面再试一次。如果问题仍然存在，请随时与我们的支持团队联系 {{supportmail}}。",
    A106B001: "检索用户货币偏好设置出错。",
    // 购物车项已结算
    CHECKOUT_ABSENCE_CART_ITEM_TITLE: "购物车项异常",
    CHECKOUT_ABSENCE_CART_ITEM_CONTENT: "待结算购物车项中已有结算的商品。请前往购物车重新选择。",
    CHECKOUT_CART_ITEM_ISSUE_TITLE: "结算异常",
    CHECKOUT_CART_ITEM_ERROR_TITLE: "结算错误",
    CHECKOUT_CART_ITEM_ISSUE_CONTENT: "待结算产品加载时发生问题。 请刷新页面再试一次。 如果问题仍然存在，请随时与我们的支持团队联系 {{supportmail}}.",
    CHECKOUT_TOTAL_PRICE_ISSUE_TITLE: "结算异常",
    CHECKOUT_TOTAL_PRICE_ERROR_TITLE: "结算错误",
    CHECKOUT_TOTAL_PRICE_ISSUE_CONTENT: "待结算产品计价时发生问题。 请刷新页面再试一次。 如果问题仍然存在，请随时与我们的支持团队联系 {{supportmail}}.",
    CHECKOUT_CURRENCY_CONFIG_MISSING_CONTENT:"{{appName}}货币设置错误。 请刷新页面并点击\“{{updateCurrencyBtn}}\”更新{{appName}}显示货币。 如果问题仍然存在，请联系{{serviceEmail}}。 ",
    CHECKOUT_CURRENCY_NONSUPPORT_CONTENT:"不支持您选择的货币。 请点击\“{{updateCurrencyBtn}}\”更新{{appName}}显示货币。",
    A106B3000601: "当前货币: {{currentCurrency}}, {{appName}}平台支持的货币类型：: {{supportCurrencies}}。",
    A106B300310: "系统中不存在货币 {{currentCurrency}}。"
}

export { language }